module.exports = __webpack_public_path__ + "img/fetch-rev-full-color_S-2.087fee02.png";